import { useCallback, useState } from 'react'

const useForceRerender = () => {
  const [_, setForceRerender] = useState(1)

  return useCallback(() => setForceRerender((prev) => prev + 1), [])
}

export default useForceRerender
